import { type PhraseRow } from '@/pages/report/utils/comparisons-data-processor';
import { type SeoList } from '@/pages/report/utils/report-table-data-processor';
import { createSlice } from '@reduxjs/toolkit';

export type SeoListExtended = SeoList & {
  foundPhrasesCount: number | null;
  totalPhrasesCount: number | null;
};

export interface CategoriesData {
  checkedPhraseIds: PhraseRow['id'][];
  listId: SeoList['id'];
  topRadioFilter: string;
  mainRadioFilter: string;
  comparisonsRadioFilter: string;
  lists: SeoListExtended[];
}

const initialState: CategoriesData = {
  checkedPhraseIds: [],
  listId: 'all',
  topRadioFilter: 'all',
  mainRadioFilter: 'all',
  comparisonsRadioFilter: 'all',
  lists: [],
};

export interface Action<P> {
  type: string;
  payload: P;
}

export const categoriesTabDataSlice = createSlice({
  name: 'categoriesTabDataSlice',
  initialState,
  reducers: {
    setCheckedPhraseIds: (state, action: Action<string[]>) => ({
      ...state,
      checkedPhraseIds: action.payload,
    }),
    setListId: (state, action: Action<string>) => ({
      ...state,
      listId: action.payload,
    }),
    setTopRadioFilter: (state, action: Action<string>) => ({
      ...state,
      topRadioFilter: action.payload,
    }),
    setMainRadioFilter: (state, action: Action<string>) => ({
      ...state,
      mainRadioFilter: action.payload,
    }),
    setComparisonsRadioFilter: (state, action: Action<string>) => ({
      ...state,
      comparisonsRadioFilter: action.payload,
    }),
    setLists: (state, action: Action<SeoListExtended[]>) => ({
      ...state,
      lists: action.payload,
    }),
    reset: () => ({ ...initialState }),
  },
});

export const {
  setCheckedPhraseIds,
  setListId,
  setTopRadioFilter,
  setMainRadioFilter,
  setComparisonsRadioFilter,
  setLists,
  reset,
} = categoriesTabDataSlice.actions;

export default categoriesTabDataSlice.reducer;
